module.exports = __webpack_public_path__ + "static/media/logIn-bg.7c6c539a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logIn-bg.png
// module id = 594
// module chunks = 0